import { can, CAPABILITY } from "../helpers/permissions";

/**
 * Child workspaces discovered from Finance.
 * Route ids and capabilities stay the existing gates.
 * Overview is the Finance screen itself and is not a child link.
 */
export const FINANCE_WORKSPACE_LINKS = Object.freeze([
  {
    id: "invoices",
    label: "Invoices",
    capability: CAPABILITY.SCREEN_INVOICE_HUB,
  },
  {
    id: "receivables",
    label: "Receivables",
    capability: CAPABILITY.SCREEN_ACCOUNTS_RECEIVABLE,
  },
  {
    id: "payables",
    label: "Payables",
    capability: CAPABILITY.SCREEN_ACCOUNTS_PAYABLE,
  },
  {
    id: "payroll",
    label: "Payroll",
    capability: CAPABILITY.SCREEN_PAYROLL_HOME,
  },
]);

export function visibleFinanceWorkspaceLinks(actor, orgPolicies) {
  return FINANCE_WORKSPACE_LINKS.filter((link) =>
    can(actor, link.capability, {}, orgPolicies),
  );
}

/**
 * The Finance directory is reachable when the actor can open the cash
 * overview OR any child workspace. Cash screens stay on SCREEN_FINANCE.
 */
export function canOpenFinanceDirectory(actor, orgPolicies) {
  if (can(actor, CAPABILITY.SCREEN_FINANCE, {}, orgPolicies)) {
    return true;
  }
  return visibleFinanceWorkspaceLinks(actor, orgPolicies).length > 0;
}
